import ISelectable from "../interfaces/selectable.interface";
import {Role} from "@leap4/auth";

export const getRoleFromISelectbleArr = (roles: ISelectable[], selectedRoleInd: number): Role[] => {
    const userRoles: Array<Role> = []

    //TODO: Bad code, enum needs to simplify.
    for (let role in Role) {
        if (role === roles[selectedRoleInd].name) {
            userRoles.push(Role[role as keyof typeof Role]);
        }
    }

    return userRoles;
}
export const getRoleIndexFromISelectableArr = (roles: ISelectable[], role: Role): number => {
    return roles.findIndex(curr =>
        curr.value === role
    )
}